<template>
  <div class="dialog-add-account__settings" v-if="show && isAdminRole">
    <div v-if="isAdminRole" class="dialog-add-account__form-title">
      {{ $t('business_account_data.role_manager') }}
    </div>
    <div v-if="isAdminRole" class="dialog-add-account__form-block">
      <Selector
        v-if="managers && managers.length"
        class="user-data__selector"
        :title="$t('active_manager')"
        :options="managers"
        @handleChange="$emit('manager-change', $event)"
        :selected="managerId"
      />
    </div>
    <!-- ID prefix  -->
    <IdPrefixInput
      :value="idPrefix"
      :show="isAdminRole"
      @input="$emit('update:id-prefix', $event)"
    />
    <!-- Platform Settings -->
    <PlatformSettings
      v-if="isAdminRole"
      :value="agencyAccountType"
      :disabled="!isEditable"
      @input="$emit('update:agency-account-type', $event)"
    />
    <!-- Course markup -->
    <CourseMarkupInput
      :value="coursePercents"
      :has-active-account="hasActiveAccount"
      :show="isAdminRole"
      @input="$emit('update:course-percents', $event)"
    />

    <!-- Рекламный сбор -->
    <AdvertisingTaxInput
      :value="advertisingTax"
      :show="isAdminRole"
      @input="$emit('update:advertising-tax', $event)"
    />

    <div v-if="isAdminRole" class="dialog-add-account__form-block">
      <div class="dialog-add-account__form-row">
        <div class="dialog-add-account__form-col">
          <VatSettings :value="taxConditions" @input="$emit('update:tax-conditions', $event)" />
        </div>
        <div class="dialog-add-account__form-col">
          <VisibilitySettings
            :value="visibleServices"
            @input="$emit('update:visible-services', $event)"
          />
        </div>
      </div>
    </div>

    <AutomationSettings
      :value="automationData"
      :show="isAdminRole"
      @update:auto_acts="$emit('update:auto-acts', $event)"
      @update:auto_cashback="$emit('update:auto-cashback', $event)"
      @update:access_api="$emit('update:access-api', $event)"
      @update:is_force_bonus="$emit('update:is-force-bonus', $event)"
    />
  </div>
</template>

<script>
import Selector from '@/components/sort/Selector';
import IdPrefixInput from './IdPrefixInput.vue';
import PlatformSettings from './PlatformSettings.vue';
import CourseMarkupInput from './CourseMarkupInput.vue';
import AdvertisingTaxInput from './AdvertisingTaxInput.vue';
import VatSettings from './VatSettings.vue';
import VisibilitySettings from './VisibilitySettings.vue';
import AutomationSettings from './AutomationSettings.vue';

export default {
  name: 'BusinessAccountSettings',
  components: {
    Selector,
    IdPrefixInput,
    PlatformSettings,
    CourseMarkupInput,
    AdvertisingTaxInput,
    VatSettings,
    VisibilitySettings,
    AutomationSettings,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    role: {
      type: String,
      required: true,
    },
    managers: {
      type: Array,
      default: () => [],
    },
    managerId: {
      type: String,
      default: '',
    },
    idPrefix: {
      type: String,
      default: '',
    },
    agencyAccountType: {
      type: Object,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    coursePercents: {
      type: Object,
      required: true,
    },
    hasActiveAccount: {
      type: Boolean,
      default: false,
    },
    advertisingTax: {
      type: Number,
      default: 3,
    },
    taxConditions: {
      type: Object,
      required: true,
    },
    visibleServices: {
      type: Object,
      required: true,
    },
    automationData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isAdminRole() {
      return this.role === 'manager' || this.role === 'finance' || this.role === 'admin';
    },
  },
  emits: [
    'manager-change',
    'update:id-prefix',
    'update:agency-account-type',
    'update:course-percents',
    'update:advertising-tax',
    'update:tax-conditions',
    'update:visible-services',
    'update:auto-acts',
    'update:auto-cashback',
    'update:access-api',
    'update:is-force-bonus',
  ],
};
</script>
